<template>
  <div class="carousel-container">
    <div class="carousel-inner centered">
      <div class="track centered">
        <div v-for="card in cards" :key="cards[card]" class="card-container centered">
          <neu-card-general :data-index="index" :src="card.src" :link="card.link"
            :title="card.title" :subtitle="card.subtitle" :titleLines="card.titleLines"
            :subtitleLines="card.subtitleLines" :iconColor="iconColor"></neu-card-general>
        </div>
      </div>
    </div>
    <div class="nav centered">
      <button style="background-color:transparent;border-color:transparent;transform: rotate(-180deg)" class="prev">
        <i class="prev">
          <base-icon class="prev" width="30" height="30" src="/static-appopensalud/img/icons/noun-arrow-blue.svg"
            :color="iconColor" /></i>
      </button>
      <button style="background-color:transparent;border-color:transparent;transform: rotate(-0deg)" class="next">
        <i class="next">
          <base-icon class="next" width="30" height="30" src="/static-appopensalud/img/icons/noun-arrow-blue.svg"
            :color="iconColor" /></i>
      </button>
    </div>
  </div>
</template>
<script>
// import NeuCardFunctions from '../ui/NeuCardFunctions.vue'
// import NeuCardFunctionsBigText from '../ui/NeuCardFunctionsBigText.vue'
export default {
    components: {
    // NeuCardFunctions,
    // NeuCardFunctionsBigText,
    'neu-card-function': () => import('@/components/base/ui/NeuCardFunctions'),
    'neu-card-general': () => import('@/components/base/ui/NeuCardGeneral'),
    'neu-card-big-text': () => import('@/components/base/ui/NeuCardFunctionsBigText')
  },
    data () {
        return {
            index: 0,
            slides: [],
            slideDirection: ''
        }
    },
    computed: {
        slidesLength () {
          return this.slides.length
        }
    },
    props: {
      cards: {
        type: Array,
        required: true
      },
      type: {
        type: String,
        require: false
      },
      iconColor: {
        type: String,
        required: false
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.initCarousel()
      })
    },
    methods: {
      initCarousel () {
        const prev = document.querySelector('.prev')
        const next = document.querySelector('.next')
        const track = document.querySelector('.track')
        const cardContainer = document.querySelector('.carousel-container')
        const cardLenght = this.cards.length - 1
        // let carouselWidth = document.querySelector('.carousel-container').offsetWidth
        let cardWidth = document.querySelector('.card-container').offsetWidth
        if (this.cards.length === 3) {
          next.classList.add('hide')
        }

        window.addEventListener('resize', () => {
					const cardContainer = document.querySelector('.card-container')
					if (cardContainer) {
						cardWidth = cardContainer.offsetWidth
					}
        })
        let index = 0
        prev.classList.add('hide')
        if (window.innerWidth <= 1052) {
          next.addEventListener('click', () => {
            index++
            prev.classList.remove('hide')
            track.style.transform = `translateX(-${index * cardWidth}px)`
            if (index === cardLenght) {
              next.classList.add('hide')
            }
          })

          prev.addEventListener('click', () => {
            index--
            next.classList.remove('hide')
            if (index === 0) {
              prev.classList.add('hide')
            }
            track.style.transform = `translateX(-${index * cardWidth}px)`
          })

          window.setInterval(() => {
            if (index < cardLenght) {
              index++
              prev.classList.remove('hide')
              track.style.transform = `translateX(-${index * cardWidth}px)`
              if (index === cardLenght) {
                next.classList.add('hide')
              }
            } else if (index === cardLenght) {
              index = index - cardLenght
              next.classList.add('hide')
              if (index === cardLenght) {
                prev.classList.remove('show')
                prev.classList.add('hide')
              }
              let i = -1
              for (i = -1; i <= cardLenght; i++) {
                track.style.transform = `translateX(-${index * cardWidth}px)`
              }
              prev.classList.add('hide')
              next.classList.remove('hide')
            }
          }, 9999999999999)
        } else {
          const cardLenght2 = cardLenght
          next.addEventListener('click', () => {
            index++
            prev.classList.remove('hide')
            track.style.transform = `translateX(-${index * cardWidth}px)`
            if ((track.offsetWidth - (index * cardWidth) < cardContainer.offsetWidth)) {
              next.classList.add('hide')
            }
          })

          prev.addEventListener('click', () => {
            index--
            next.classList.remove('hide')
            if (index === 0) {
              prev.classList.add('hide')
            }
            track.style.transform = `translateX(-${index * cardWidth}px)`
          })
          window.setInterval(() => {
            if (index < cardLenght2) {
              index++
              prev.classList.add('show')
              track.style.transform = `translateX(-${index * cardWidth}px)`
              //  if (cardLenght2 <= 3) {
              // movement.style.transform = `translateX(${index * 42}rem)`
              // } else {
              // movement.style.transform = `translateX(${index * cardLenght2}rem)`
              // }
              if (track.offsetWidth - (index * cardWidth) < cardContainer.offsetWidth) {
                next.classList.add('hide')
              }
            }
            if (index === cardLenght2) {
              index = index - cardLenght2
              next.classList.remove('hide')
              if (index === 0) {
                prev.classList.remove('show')
              }
              let i = -1
              for (i; i <= cardLenght2; i++) {
                track.style.transform = `translateX(-${index * cardWidth}px)`
              }
            }
          }, 99999999997000)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
.carousel-container {
  width: 1280px;
  margin: -2rem auto 0 auto;
  min-height: 200px;
  position: relative;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .carousel-container {
    width: 80%;
  }
}
@media screen and (max-width: 1000px) {
  .carousel-container {
    width: 100%;
  }
}
@media screen and (min-width: 1001px) and (max-width: 1440px) {
  .carousel-container {
    width: 85%;
  }
}
.carousel-container .carousel-inner {
  overflow: hidden;
  background-color: transparent;
   @media screen and (min-width: 1100px) and (max-width: 1281px) {
      width: 113% !important;

    }
    @media screen and (max-width: 320px) {
      width: 20rem;

    }
 @media screen and (min-width: 321px) and (max-width: 425px) {
      width: 100%;

    }
}
.carousel-container .track {
  display: inline-flex;
  transition: transform 0.5s;
  // padding-bottom: 3rem;
}
.carousel-container .card-container {
  flex-shrink: 0;
  overflow: initial;
  box-sizing: border-box;
  @include desktop {
     @media screen and (min-width: 1281px) and (max-width: 1324px) {
        padding-top: 5rem;
      padding-right: 4rem;
      padding-left: 4rem;
      padding-bottom: 3rem;     
      width: 30rem;
    }
     @media screen and (min-width: 1324px) and (max-width: 1452px) {
        padding-top: 5rem;
      padding-right: 3rem;
      padding-left: 5rem;
      padding-bottom: 3rem;     
      width: 30rem;
    }
     @media screen and (min-width: 1452px) {
       padding-top: 5rem;
      padding-right: 5rem;
      padding-left: 5rem;
      padding-bottom: 3rem;     
      width: 30rem;
    }
     

  }
  @include desktop-sm {
     @media screen and (min-width: 1024px) and (max-width: 1062px) {
        padding-top: 4rem;
        padding-right: 3rem;
        padding-left: 3rem;
        padding-bottom: 3rem;  
        width: 25rem;
        height: 38rem;
    }
   @media screen and (min-width: 1063px) and (max-width: 1130px) {
        padding-top: 4rem;
        padding-right: 3rem;
        padding-left: 3rem;
        padding-bottom: 3rem;  
        width: 27rem;
        height: 38rem;
    }
    @media screen and (min-width: 1131px) and (max-width: 1281px) {
        padding-top: 4rem;
        padding-right: 3rem;
        padding-left: 3rem;
        padding-bottom: 3rem;  
        width: 27rem;
        height: 38rem;
    }

  }
  @include tablets {
     @media screen and (min-width:768px) and (max-width: 814px) {
        padding-top: 4rem;
        padding-right: 5rem;
        padding-left: 5rem;
        padding-bottom: 5rem;        
        width: 35rem;
        height: 38rem;
      }
  @media screen and (min-width:815px) and (max-width: 1024px) {
        padding-top: 5rem;
        padding-right: 2rem;
        padding-left: 1rem;
        padding-bottom: 2rem;
        width: 23rem;
      }

  }
  @include mobile(){
    @media screen and (min-width:321px) and (max-width: 375px) {
    padding-top: 5rem;
    padding-right: 16rem;
    padding-bottom: 2rem;
    width: 33rem;
       }
   @media screen and (min-width:376px) and (max-width: 425px) {
    padding-top: 5rem;
    padding-right: 16rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    width: 37rem;
       }
       @media screen and (min-width:426px) and (max-width: 565px) {
    padding-top: 5rem;
    padding-right: 15rem;
    padding-left: 3rem;
    padding-bottom: 2rem;
    width: 37rem;
       }
       @media screen and (min-width:566px) and (max-width: 768px) {
    padding-top: 5rem;
    padding-right: 11rem;
    padding-left: 4rem;
    padding-bottom: 2rem;
    width: 37rem;
       }
    // width: 30rem;
    @media screen and (max-width: 320px) {
      padding-top: 5rem;
      padding-right: 16rem;
      padding-bottom: 2rem;
      width: 32rem;
    }
  };

}
.carousel-container .card-container .card {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 10px;
  display: contents;
  flex-direction: column;
}
.nav {
  width: 50%;
  // left: 50%;
  top: 50%;
  position: absolute;
}
.nav button {
  border-radius: 50%;
  border: 1px solid #aaa;
  position: absolute;
  background-color: transparent;
  transform: translateY(-50%);
  cursor: pointer;
}
.nav .prev {
  right: 100%;
}
.nav .prev.show {
  display: block;
}
.nav .next {
  left: 200%;
}
.nav .next.hide {
  display: none;
}
.nav .prev.hide {
  display: none;
}
 .button-line {
    position: relative;
    border-top: 1px solid black;
    vertical-align:bottom;
    flex-direction: column;
    @include desktop {
      margin-top: 4rem;
    }
  }
.card > * {
  flex: 1;
}
.card .img {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
.card .info {
  flex-basis: 40px;
  background: #333;
  color: #fff;
  flex-grow: 0;
  padding: 10px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/base/carousel/Carousel2.vue